import React, { useCallback, useRef } from 'react';
import styles from './BannerFullWidthLargeText.module.scss';
import ImagePoints from '../../Components/ImageComponent/ImagePoints';
import MenuTiles from '../../../MenuTiles/MenuTiles';
import TitleComponent from '../../Components/TitleComponent/TItleComponent';
import GrandPage from '../../Components/GrandPage/GrandPage';
import { imageWrapperWithButtonRefFunction, TitleOverlayWrapper } from '../../../../functions';

const BannerFullWidthLargeText = ({ api }) => {
  const titleRef = useRef();

  const imageWrapperWithButtonRef = useCallback((node) => {
    imageWrapperWithButtonRefFunction(node);
  }, []);

  return (
    <section
      id={api?.id}
      className={`${styles.container} ${
        api.attributes?.image?.imagePointsCoordinates || api.attributes?.image?.imagePointsYellow ? styles.scrollBtn : ''
      }`}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      <div className={styles.topMainContainer}>
        <div
          ref={imageWrapperWithButtonRef}
          className={`${styles.topContainer} ${styles.imageWrapperWithButton}`}
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          <div className={styles.imagePointsWrapper}>
            <ImagePoints properties={api.attributes} />
          </div>
        </div>
        <TitleOverlayWrapper styles={styles} titleWrapperRef={titleRef}>
          <div className={styles.content}>
            <TitleComponent
              ref={titleRef}
              type="afterBgSec f-300"
              properties={api.attributes}
              animationData={{ animation: 'fade-right', animationDuration: '1000', animationEasing: 'easy-in-out' }}
            />
          </div>
        </TitleOverlayWrapper>
      </div>
      <div className={styles.downContainer} data-aos-duration="500" data-aos-easing="ease-in-out" data-aos-once="false">
        <GrandPage properties={api.attributes} blockID={api.id} />
      </div>
    </section>
  );
};

export default BannerFullWidthLargeText;
